import { useT } from '../../i18n/LocaleProvider.js';

/**
 * 좌측 내비 — 편성표 · 설정 **둘** (`docs/63` §2.1). 「홈」 항목은 렌더하지 않는다 — 현재
 * 화면이고, **없는 버튼은 후보가 아니다**(절대 규칙 29). 접힘/펼침은 CSS(`:focus-within` ·
 * `:hover`)이고 JS 상태가 없다.
 *
 * **DOM 에서 masthead 뒤에 온다** — `entryFocusIndex` 는 DOM 순서의 가장 앞이라 앞에 두면
 * 리모컨의 첫 착지점이 CTA 가 아니라 내비가 된다(`StartGate` 가 「방송편성 보기」를 뒤에 둔
 * 것과 같은 이유 · `docs/63` §6.2).
 */
export function SideNav({
  onOpenGuide,
  onOpenSettings,
}: {
  onOpenGuide: (() => void) | null;
  onOpenSettings: () => void;
}) {
  const t = useT();
  return (
    <nav className="home__nav" aria-label={t('home.nav.guide')}>
      {onOpenGuide !== null && (
        <button
          type="button"
          className="home__nav-item"
          data-testid="home-nav-guide"
          onClick={onOpenGuide}
        >
          <span className="home__nav-icon" aria-hidden="true">
            ▤
          </span>
          <span className="home__nav-label">{t('home.nav.guide')}</span>
        </button>
      )}
      <button
        type="button"
        className="home__nav-item home__nav-item--bottom"
        data-testid="home-nav-settings"
        onClick={onOpenSettings}
      >
        <span className="home__nav-icon" aria-hidden="true">
          ⚙
        </span>
        <span className="home__nav-label">{t('watch.settings')}</span>
      </button>
    </nav>
  );
}
